var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ELSCommonUIConstants } from 'components/common';
import { analyticBaseConfig } from 'config/app.config';
import { ROUTE_ROLES } from 'constants/app.constant';
import { lazy } from 'react';
import withWguRouteGuard from 'reports/cw/components/common/with-wgu-route-guard/withWguRouteGuard';
import { EHR_PRODUCT_NAME, ehrPath } from 'reports/ehr/constants/ehr.constant';
var INSTRUCTOR = ROUTE_ROLES.INSTRUCTOR;
var baseRoutes = [
    {
        path: ehrPath.ehrStudentDetail,
        component: lazy(function () { return import(/* webpackChunkName: "EHRStudentDetail" */ 'reports/ehr/components/pages/ehr-student-detail/EHRStudentDetail'); }),
        data: {
            analytics: {
                pageType: ELSCommonUIConstants.analytics.pageTypes.performanceStats,
                pageName: "".concat(analyticBaseConfig.edApp, ":ehr-student-detail"),
                pageProductName: EHR_PRODUCT_NAME
            }
        },
        isPrivate: true,
        roles: INSTRUCTOR
    },
    {
        path: ehrPath.ehrHome,
        component: lazy(function () { return import(/* webpackChunkName: "EHRHome" */ 'reports/ehr/components/pages/ehr-home/EHRHome'); }),
        data: {
            analytics: {
                pageType: ELSCommonUIConstants.analytics.pageTypes.performanceStats,
                pageName: "".concat(analyticBaseConfig.edApp, ":ehr-dashboard"),
                pageProductName: EHR_PRODUCT_NAME
            }
        },
        isPrivate: true,
        roles: INSTRUCTOR
    }
];
export var EhrRoutes = {
    // The WGU experience is CW student search only, so EHR pages redirect back to the CW home.
    getRoutes: function () { return baseRoutes.map(function (route) { return (__assign(__assign({}, route), { component: withWguRouteGuard(route.component) })); }); }
};
